import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import {
  Button,
  Form,
  Grid,
  Header,
  Image,
  Message,
  Segment,
  Divider,
} from "semantic-ui-react";
import { renderTextField } from "../formcomponents";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import { encryptData, decryptData, secretKey } from "../store/Encrypt";
const Login = (props) => {
  const { handleSubmit } = props;
  const [serverRes, setserverRes] = useState("");
  const [alertColor, setalertColor] = useState("");
  const navigate = useNavigate();

  // "email": "parmarjis@gmail.com",
  // "userPassword": "MALIparmar2024",  PARMAR66mali98
  const submitToApi = (values) => {
    console.log(values);

    axios
      .post(BaseUrl + "checkBackOfficeUser", values)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errCode === 121) {
          setserverRes(res.data.errMessage);
          setalertColor("red");
          setTimeout(() => {
            setserverRes();
            setalertColor();
          }, 5000);
        } else if (res.data.errCode === 200) {
          const encryptedJSON = encryptData(res.data, secretKey);
          // console.log("Encrypted JSON:", encryptedJSON);

          // const decryptedJSON = decryptData(encryptedJSON, secretKey);
          // console.log("Decrypted JSON:", decryptedJSON);

          // replace this with your actual authentication token
          Cookies.set("authTokens", encryptedJSON, { expires: 7 }); // set the cookie with a 7-day expiration
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // if (values.userEmail == "admin" && values.userPassword == "admin") {
    //   const authToken = "silveradmin"; // replace this with your actual authentication token
    //   Cookies.set("authTokens", authToken, { expires: 7 }); // set the cookie with a 7-day expiration
    //   navigate("/dashboard");
    // }
  };
  return (
    <div id="grad1">
      <Grid
        style={{ height: "100vh" }}
        verticalAlign="middle"
        className="loginForm"
      >
        <Grid.Column style={{ maxWidth: 450 }}>
          <Header as="h2" color="teal" textAlign="center">
            <Image src="/logo.png" /> Log-in to your account
          </Header>
          <Form size="large">
            {serverRes && <Message color={alertColor}>{serverRes}</Message>}

            <Segment stacked>
              <Field
                name="email"
                label="Email"
                type="text"
                component={renderTextField}
              />
              <Field
                name="userPassword"
                label="Password"
                type="password"
                component={renderTextField}
              />
              <Divider />
              <Button
                color="teal"
                fluid
                size="large"
                onClick={handleSubmit((values) =>
                  submitToApi({
                    ...values,
                  })
                )}
              >
                Login
              </Button>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default reduxForm({
  form: "Login",
})(Login);
